import H1 from "./H1";
import H2 from "./H2";
import H3 from "./H3";
import H4 from "./H4";
import P1 from "./P1";
import P2 from "./P2";
import P3 from "./P3";
import P4 from "./P4";

// sets a default & fallback
const Typography = P1;

Typography.H1 = H1;
Typography.H2 = H2;
Typography.H3 = H3;
Typography.H4 = H4;
Typography.P1 = P1;
Typography.P2 = P2;
Typography.P3 = P3;
Typography.P4 = P4;

export default Typography;
